import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/production',
  component: layout,
  meta: {
    funcID: 'F0005',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'workshop',
      name: `${pre}workshop`,
      meta: {
        ...meta,
        head: { back: false },
        title: '生产车间',
        funcID: 'F000506',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/workshop'),
    },
    {
      path: 'workshop/:pageType/:code?',
      name: `${pre}workshop-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { workShopName = '' } = $route.query || {}
          return workShopName || '生产车间'
        },
        funcID: 'F000506',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/workshop/detail'),
    },
    {
      path: 'maintenance',
      name: `${pre}maintenance`,
      meta: {
        ...meta,
        head: { back: false },
        title: '产线设备维护',
        funcID: 'F000508',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/maintenance'),
    },
    {
      path: 'productionLineGroup',
      name: `${pre}productionLineGroup`,
      meta: {
        ...meta,
        head: { back: false },
        title: '产线人员分组',
        funcID: 'F000507',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/productionLineGroup'),
    },
    {
      path: 'orderTechPricing',
      name: `${pre}orderTechPricing`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单产品工价维护',
        funcID: 'F000509',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/orderTechPricing'),
    },
    {
      path: 'orderTechPricing/:pageType/:code?',
      name: `${pre}orderTechPricing-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderTechPricingNo = '' } = $route.query || {}
          return `订单产品工价维护 | ${orderTechPricingNo || 'New'}`
        },
        funcID: 'F000509',
        PID: 'F00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () =>
        import('@/views/factory/production/orderTechPricing/detail'),
    },
    {
      path: 'prodLineReport',
      name: `${pre}prodLineReport`,
      meta: {
        ...meta,
        head: { back: false },
        title: '产线报工记录',
        funcID: 'F000510',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/prodLineReport'),
    },
    {
      path: 'prodLineQualityRecord',
      name: `${pre}prodLineQualityRecord`,
      meta: {
        ...meta,
        head: { back: false },
        title: '产线质检记录',
        funcID: 'F000511',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/production/prodLineQualityRecord'),
    },
    {
      path: 'packReportRecord',
      name: `${pre}packReportRecord`,
      meta: {
        ...meta,
        head: { back: false },
        title: '包装报工记录',
        funcID: 'F000512',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/packReportRecord'),
    },
    {
      path: 'defectAnalytics',
      name: `${pre}defectAnalytics`,
      meta: {
        ...meta,
        head: { back: false },
        title: '不良品分类统计',
        funcID: 'F000513',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/defectAnalytics'),
    },
    {
      path: 'quality-inspection',
      name: `${pre}qualityInspection`,
      meta: {
        ...meta,
        head: { back: false },
        title: '质检报工记录',
        funcID: 'F000514',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/qualityInspection'),
    },
    {
      path: 'rework-report',
      name: `${pre}reworkreport`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000515',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/reworkreport'),
    },
    {
      path: 'qualityIssues',
      name: `${pre}qualityIssues`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000516',
        PID: 'F00',
      },
      component: () => import('@/views/factory/production/qualityIssues'),
    },
  ])('production-'),
}
